/**
 * Environment Style Loader
 * 
 * This utility loads CSS variables from environment variables.
 * Add environment variables with the prefix REACT_APP_STYLE_ to override CSS variables.
 * 
 * Example:
 * REACT_APP_STYLE_INPUT_PADDING=10px 20px
 */

export const loadEnvStyles = () => {
  // Access all environment variables
  const envVars = process.env;
  
  // Create a style object
  const styleVars: Record<string, string> = {};
  
  // Extract style variables from environment (prefixed with REACT_APP_STYLE_)
  Object.keys(envVars).forEach(key => {
    if (key.startsWith('REACT_APP_STYLE_')) {
      // Convert REACT_APP_STYLE_INPUT_PADDING to --input-padding
      const cssVarName = '--' + key
        .replace('REACT_APP_STYLE_', '')
        .toLowerCase()
        .replace(/_/g, '-');
      
      styleVars[cssVarName] = envVars[key] as string;
    }
  });
  
  // Apply CSS variables to :root
  Object.keys(styleVars).forEach(varName => {
    document.documentElement.style.setProperty(varName, styleVars[varName]);
  });
  
  console.log('Loaded environment styles:', styleVars);
};

export default loadEnvStyles; 